module.exports = __webpack_public_path__ + "img/arrDown.954246c8.svg";